import { get } from 'lodash-es';

const byIsLoading = (state: any) => get(state, 'properties.isLoading', false);

export default byIsLoading;
